<div class="zhh-reality-check-alert-container">
	<div class="zhh-reality-check-alert-header">
		<img obgImageContent="responsible-gaming.time-out" obgImageContentGroup="common" />
		<h1 class="zhh-reality-check-alert-header-text" [innerHTML]="data?.title"></h1>
	</div>

	<div class="zhh-reality-check-alert-content">
		<p class="zhh-reality-check-alert-content-strong" [innerHTML]="data?.dialogContent"></p>
		<p [innerHTML]="data?.dialogContentSubText"></p>
	</div>
</div>
